const initialState = {
  fetchAllLgPending: false,
  fetchAllLgError: null,
  fetchLgDetailPending: [],
  fetchLgDetailError: {},
  lhoData: { properties: [] },
  location: null,
  accuracy: null,
  mapCenter: null,
  zoomLevel: null,
  updateCurrentLocationPending: false,
  updateCurrentLocationError: null,
}
export default initialState



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js